import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {BankCheckSummaryModel} from '../bankCheckSummary.model';
import {PermissionsConverter} from '../../../../../common/converter/permissions.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';


@Injectable({providedIn: 'root'})
export class BankCheckSummaryConverter extends HttpModelConverter<BankCheckSummaryModel> {
    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): BankCheckSummaryModel {
        return new BankCheckSummaryModel();
    }

    protected enrichObject(result: BankCheckSummaryModel, src: BankCheckSummaryModel) {
        result.permissions = new PermissionsConverter().convert(src.permissions);
        result.status = this.lovValueSummaryConverter.convert(src.status);
    }
}

